// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CenterOnAnchorController from "./center_on_anchor_controller"
application.register("center-on-anchor", CenterOnAnchorController)

import ConfirmModalController from "./confirm_modal_controller"
application.register("confirm-modal", ConfirmModalController)

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DebounceController from "./debounce_controller"
application.register("debounce", DebounceController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ExerciseAutocompleteController from "./exercise_autocomplete_controller"
application.register("exercise-autocomplete", ExerciseAutocompleteController)

import ExerciseAutofillController from "./exercise_autofill_controller"
application.register("exercise-autofill", ExerciseAutofillController)

import ExerciseChartController from "./exercise_chart_controller"
application.register("exercise-chart", ExerciseChartController)

import ExerciseSetsController from "./exercise_sets_controller"
application.register("exercise-sets", ExerciseSetsController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LandingMenuController from "./landing_menu_controller"
application.register("landing-menu", LandingMenuController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import NestedExercisesController from "./nested_exercises_controller"
application.register("nested-exercises", NestedExercisesController)

import PhoneMaskController from "./phone_mask_controller"
application.register("phone-mask", PhoneMaskController)

import PlanActionsController from "./plan_actions_controller"
application.register("plan-actions", PlanActionsController)

import RestTimerController from "./rest_timer_controller"
application.register("rest-timer", RestTimerController)

import ScrollAnimateController from "./scroll_animate_controller"
application.register("scroll-animate", ScrollAnimateController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SetCompletionController from "./set_completion_controller"
application.register("set-completion", SetCompletionController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TextRevealController from "./text_reveal_controller"
application.register("text-reveal", TextRevealController)

import TimerTriggerController from "./timer_trigger_controller"
application.register("timer-trigger", TimerTriggerController)

import WorkoutDayController from "./workout_day_controller"
application.register("workout-day", WorkoutDayController)

import WorkoutTimerController from "./workout_timer_controller"
application.register("workout-timer", WorkoutTimerController)
